function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  .st0{fill:#DBF3FF;}\n  .st1{fill:#99ACBB;}\n  .st2{fill:#95ABB9;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 84,
  cy: 84,
  r: 82.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M112,62.7h-7c-1.7,0-3-1.3-3-3v-6.1h-1.9v5.9c0,2.8,2.2,5,5,5h6.9V62.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M104,49.7H61c-2.8,0-5,2.2-5,5v62.8c0,2.8,2.2,5,5,5h50c2.8,0,5-2.2,5-5V60.6L104,49.7z M114.2,117.5       c0,1.7-1.3,3-3,3H60.8c-1.7,0-3-1.3-3-3v-63c0-1.7,1.3-3,3-3H103l11.1,10.1V117.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M53.8,115.5l0-65.1c0-1.7,1.3-3,3-3H101v-1.9H57c-2.8,0-5,2.2-5,5v64.9H53.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M98.8,89.7c0,7.1-5.7,12.8-12.8,12.8c-7.1,0-12.8-5.7-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8       c3.9,0,7.4,1.7,9.7,4.5h2.7c-2.7-4-7.3-6.7-12.5-6.7c-8.3,0-15,6.7-15,15s6.7,15,15,15c8.3,0,15-6.7,15-15c0-0.4,0-0.7-0.1-1.1       h-2.2C98.8,88.9,98.8,89.3,98.8,89.7z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 96.9,
  y: 75.4,
  className: "st1",
  width: 2.1,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 92,
  y: 80.4,
  className: "st1",
  width: 7,
  height: 2.1
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "86,85 87.2,87.4 89.8,87.8 87.9,89.6 88.4,92.3 86,91 83.6,92.3 84.1,89.6 82.2,87.8 84.8,87.4    "
})));

var SvgActivitiesEmpty = function SvgActivitiesEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 168 168",
    style: {
      enableBackground: "new 0 0 168 168"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivitiesEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activities_empty.da99d971.svg";
export { ForwardRef as ReactComponent };